// Configuration for API services
// export const SERVER_URL = import.meta.env.VITE_API_URL || "http://localhost:8092/";
export const SERVER_URL =
  import.meta.env.VITE_API_URL || "https://api.vellabloombookings.com/";

// HTTP options for authenticated requests
export const getHttpOptions = () => {
  const token = localStorage.getItem("token");
  return {
    headers: {
      "Content-Type": "application/json",
      Authorization: token ? `Bearer ${token}` : "",
    },
  };
};

// HTTP options for multipart requests
export const httpOptionsMult = {
  headers: {
    "Content-Type": "multipart/form-data",
  },
};

// HTTP options for requests without token (login, etc.)
export const httpOptionsWithOutToken = {
  headers: {
    "Content-Type": "application/json",
  },
};
